export default {
  entry_values: [],
  default: null,
  required: false,
  read_only: false,
  summary_entry: {},
  style: null,
  mask: null,
  barcode_enabled: null,
  allow_unsecured_access: false,
  export_label: null,
  receipt_label: null,
  report_label: null,
  inserts_page_break_at_the_end: false,
  follow_up_enabled: false,
  reference_data_id: null,
  reference_data_column: null,
  dependent_entry: null,
  barcode_enabled: null,
  integration_form: false,
  auto_email_subject: false,
  auto_email_body: false,
  auto_email_filename: false,
  auto_submission_name: false,
  uses_caption_format: false,
  visible: true,
  pdf_visibility: 0,
  web_visibility: 0,
  minimum: null,
  maximum: null,
  gps_accuracy: null,
  gps_timeout: null,
  zoom_level: null,
  gps_display_type: null,
  length: null,
  dependent_form_id: null
};